const en = {
  filter: {
    webSite: 'Website',
    all: 'All',
    status: 'Status',
    remitted: 'SUCCESS',
    remitting: 'INPROCESS',
    date: 'Date',
    selectDate: 'Select the date',
    quicklySelect: {
      lab: 'Quick selection',
      range: {
        today: 'Today',
        lastWeek: 'Last week',
        lastMonth: 'Last month',
        lastYear: 'Last year'
      }
    }
  },
  tableColumns: {
    withdrawalTime: 'Withdrawal Time',
    paymentBatchNo: 'Transaction ID',
    childFlowID: 'Subtransaction ID',
    withdrawalFlowID: 'Withdrawal Flow ID',
    webSite: 'Website',
    groupName: 'Group',
    paymentAccount: 'Payment Account',
    withdrawalAmount: 'Withdrawal Amount',
    withdrawalFee: 'Withdrawal Fee',
    transferredAmount: 'Transferred Amount',
    remittanceTime: 'Remittance Time',
    remittanceStatus: 'Remittance Status',
    orderStatus: 'Order Status',
    status: 'Status',
    noData: 'No Data'
  }
}

export default en
